import { RefinementCtx, ZodIssueCode } from 'zod';
import { EmptyValidationMessage, FieldValues, Path, mapDropDown } from '@ninja/utilities';
import { PolicyType, Relationship, isEmirateCountry } from '../../../../../common';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';
import { useCountries } from '../../../../app-init-data';
import { prepareFieldError } from '../helpers/add-field-error';

export const useNationalityField = <TForm extends FieldValues>() => {
	const { translate: t } = useAppPlatformContextOptions();
	const { countries } = useCountries();
	const getField = ({ field }: { field: Path<TForm> }) =>
		mapDropDown({
			field,
			isSearchable: true,
			label: t('members:fields.nationality.label'),
			placeholder: t('members:fields.nationality.placeholder'),
			options: countries,
			valueKey: 'id',
			labelKey: 'name',
		});

	const getValidation = (
		nationalityId: number | undefined,
		policyTypeId: PolicyType | undefined,
		relationship: Relationship | undefined,
		ctx: RefinementCtx
	) => {
		const addFieldError = prepareFieldError(ctx);

		if (!nationalityId) addFieldError({ field: 'nationalityId', message: EmptyValidationMessage });

		if (
			isEmirateCountry(nationalityId) &&
			policyTypeId &&
			([PolicyType.OnlyMe, PolicyType.MeAndFamily].includes(policyTypeId) ||
				(relationship !== Relationship.Self &&
					[PolicyType.DomesticWorker, PolicyType.OnlyFamily].includes(policyTypeId)))
		) {
			ctx.addIssue({
				code: ZodIssueCode.invalid_enum_value,
				received: policyTypeId,
				path: ['nationalityId'],
				message: EmptyValidationMessage,
				options: [],
			});
		}
	};

	return {
		getField,
		getValidation,
	};
};
